import styled from "@emotion/styled";

export const Container = styled.div`
  background-color: #f7fafc;
  @media (max-width: 767px) {
    padding-top: 3.125rem;
  }
`;

export const InnerWrapper = styled.div`
  max-width: 87.5rem;
  margin: 0 auto;
  padding: 0rem 1.25rem;
`;

//-----------------

export const ListWrapper = styled.div`
  margin-top: 15px;
  padding-bottom: 25px;
`;

export const DetailTitle = styled.span`
  display: block;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  color: #2f8de4;
`;

export const ToggleWrapper = styled.div`
  max-width: 225px;
  margin: 0 auto;
`;

export const SubscriptionTiersWrapper = styled.div`
  display: flex;
  text-align: left;
  justify-content: center;
  flex-grow: 1;
  flex-wrap: wrap; /* Ensures responsiveness */
  gap: 30px; /* Adds spacing between items */
  padding: 40px 20px;
  margin: 0 auto;
`;

export const SubscriptionTierCard = styled.section`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  width: 100%;
  flex: 1 1 calc(33.33% - 20px); /* Allows it to shrink and respect 3-column layout */
  min-width: 280px;
  max-width: 390px;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease-in-out;
  margin-top: 25px;

  &.highlight {
    border: 0.125rem dashed #2f8de4;
    background-color: #e5f0f9;
  }
`;

export const TopContentWrapper = styled.div`
  button {
    margin-top: 15px;
    width: 100%;
  }
`;

export const PriceWrapper = styled.div`
  margin-top: 15px;
`;

export const FeatureRow = styled.div`
  display: flex;
  align-items: center;
  padding: 7.5px 0;
  gap: 10px;
  &:last-of-type {
    padding-bottom: 0;
  }
`;

export const FeatureTitle = styled.span`
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  color: grey;
  font-size: 14px;
`;

export const FeatureIcon = styled.span`
  font-size: 18px;
  color: grey;
  &.check {
    color: #5ea980;
  }
`;

export const FreeTierWrapper = styled.div`
  text-align: center;
`;

export const FreeTierDescriptionWrapper = styled.div`
  max-width: 580px;
  margin: 0 auto;
`;

export const ListTitle = styled.h2``;

export const ListGroup = styled.div`
  margin-top: 20px;
  &:first-of-type {
    padding-bottom: 10px;
  }
`;
